import React from 'react';
import { FiX, FiFileText } from 'react-icons/fi';

export default function PaymentUploadModal({ isOpen, onClose, formData, setFormData, onSubmit, classes = [] }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm">
            <div className="bg-white rounded-3xl w-full max-w-lg shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
                <div className="px-8 py-6 bg-blue-600 text-white flex justify-between items-center">
                    <h3 className="text-xl font-bold">Submit Payment Slip</h3>
                    <button onClick={onClose} className="hover:rotate-90 transition-transform">
                        <FiX size={24} />
                    </button>
                </div>

                <form onSubmit={onSubmit} className="p-8 space-y-5">
                    <div className="space-y-4">
                        <div>
                            <label className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-2 block">Select Class</label>
                            <select
                                className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium focus:outline-none focus:border-blue-500"
                                value={formData.classId}
                                onChange={(e) => setFormData({ ...formData, classId: e.target.value })}
                                required
                            >
                                <option value="">Choose Class</option>
                                {classes.map(cls => (
                                    <option key={cls.id} value={cls.id}>{cls.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-2 block">Month</label>
                                <select
                                    className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium focus:outline-none focus:border-blue-500"
                                    value={formData.month}
                                    onChange={(e) => setFormData({ ...formData, month: e.target.value })}
                                    required
                                >
                                    <option value="">Month</option>
                                    {['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].map(m => (
                                        <option key={m} value={m}>{m}</option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <label className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-2 block">Amount (LKR)</label>
                                <input
                                    type="number"
                                    placeholder="2700"
                                    className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium focus:outline-none focus:border-blue-500"
                                    value={formData.amount}
                                    onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <label className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-2 block">Reference No</label>
                            <input
                                type="text"
                                placeholder="Bank Ref / ATM No"
                                className="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium focus:outline-none focus:border-blue-500"
                                value={formData.referenceNo}
                                onChange={(e) => setFormData({ ...formData, referenceNo: e.target.value })}
                                required
                            />
                        </div>

                        <div className="pt-2">
                            <label className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-2 block">Upload Slip Image</label>
                            <div className="border-2 border-dashed border-gray-200 rounded-2xl p-8 text-center hover:border-blue-400 transition-colors cursor-pointer relative">
                                <input
                                    type="file"
                                    className="absolute inset-0 opacity-0 cursor-pointer"
                                    onChange={(e) => setFormData({ ...formData, slip: e.target.files[0] })}
                                    required
                                />
                                <div className="flex flex-col items-center gap-2">
                                    <FiFileText size={32} className="text-gray-300" />
                                    <p className="text-sm font-bold text-gray-500">
                                        {formData.slip ? formData.slip.name : "Click to select or drag and drop"}
                                    </p>
                                    <p className="text-[10px] text-gray-400">PNG, JPG up to 5MB</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button type="submit" className="w-full py-4 bg-blue-600 text-white font-black rounded-2xl shadow-xl shadow-blue-200 hover:bg-blue-700 transition-all uppercase tracking-widest text-sm mt-4">
                        Confirm Submission
                    </button>
                </form>
            </div>
        </div>
    );
}
